const fieldSizing = {
  name: "field-sizing",
  path: "/field-sizing",
  title: "field-sizing",
  description: "Utilities for controlling the sizing of form controls.",
  value: {
    "field-sizing": {
      "field-sizing-fixed": "fixed",
      "field-sizing-content": "content"
    }
  },
  exampleData: [
    {
      example: {
        code: `<input class="field-sizing-fixed border p-2" type="text" placeholder="Fixed sizing" />
<input class="field-sizing-content border p-2" type="text" placeholder="Content sizing" />`
      }
    }
  ],
  htmlData: [
    {
      title: "Field sizing",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">field-sizing-fixed</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">field-sizing-content</code> to control the field-sizing property.
      </p>
      <div class="flex gap-8 items-center justify-center">
        <textarea rows="2" class="mx-auto block field-sizing-fixed w-80 rounded-md p-2 text-sm text-color-gray-950 outline-1 outline-color-gray-900/10 focus:outline-2 focus:outline-color-gray-900 dark:bg-color-gray-950/25 dark:text-color-white dark:outline-1 dark:outline-color-white/5 dark:focus:outline-color-white/20" spellcheck="false">Latex Salesman, Vanderlay Industries</textarea>
        <textarea rows="2" class="mx-auto block field-sizing-content w-80 rounded-md p-2 text-sm text-color-gray-950 outline-1 outline-color-gray-900/10 focus:outline-2 focus:outline-color-gray-900 dark:bg-color-gray-950/25 dark:text-color-white dark:outline-1 dark:outline-color-white/5 dark:focus:outline-color-white/20" spellcheck="false">Latex Salesman, Vanderlay Industries</textarea>
      </div>
      `
    }
  ]
};

export default fieldSizing;
<div class="flex gap-8 items-center justify-center sr-only">
        <textarea rows="2" class="mx-auto block field-sizing-fixed w-80 rounded-md p-2 text-sm text-color-gray-950 outline-1 outline-color-gray-900/10 focus:outline-2 focus:outline-color-gray-900 dark:bg-color-gray-950/25 dark:text-color-white dark:outline-1 dark:outline-color-white/5 dark:focus:outline-color-white/20" spellcheck="false">Latex Salesman, Vanderlay Industries</textarea>
        <textarea rows="2" class="mx-auto block field-sizing-content w-80 rounded-md p-2 text-sm text-color-gray-950 outline-1 outline-color-gray-900/10 focus:outline-2 focus:outline-color-gray-900 dark:bg-color-gray-950/25 dark:text-color-white dark:outline-1 dark:outline-color-white/5 dark:focus:outline-color-white/20" spellcheck="false">Latex Salesman, Vanderlay Industries</textarea>
</div>